import { render } from "./PatientInformation.vue?vue&type=template&id=4b6efd69&scoped=true"
import script from "./PatientInformation.vue?vue&type=script&lang=js"
export * from "./PatientInformation.vue?vue&type=script&lang=js"

import "./PatientInformation.vue?vue&type=style&index=0&id=4b6efd69&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6efd69"],['__file',"src/components/sendOuts/PatientInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b6efd69"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b6efd69', __exports__)) {
    console.log('reload')
    api.reload('4b6efd69', __exports__)
  }
  
  module.hot.accept("./PatientInformation.vue?vue&type=template&id=4b6efd69&scoped=true", () => {
    console.log('re-render')
    api.rerender('4b6efd69', render)
  })

}


export default __exports__